import * as React from "react";
import { useUser } from "../globalState";
import { useActiveInfluencer } from "../services/ActiveInfluencer";
import { featureFlags } from "../util";

export default function useDashboardCtx() {
  const user = useUser();
  const activeInfluencer = useActiveInfluencer();

  return React.useMemo(
    () => ({ user, activeInfluencer, flags: featureFlags }),
    [user, activeInfluencer],
  );
}
